<template>
  <main class="flex justify-center bg-[#0062C4] py-12">
    <div class="w-full" style="font-family: Arial">
      <img
        src="@/assets/images/logo-mixa-min.png"
        class="max-w-[250px] m-auto mb-12"
      />
      <ul>
        <li class="flex relative">
          <h2>
            <b>{{ goodies1 }}</b>
          </h2>
          <span @click="remGd1">-</span>
          <p>BANDEAU</p>
          <span @click="addGd1">+</span>
        </li>
        <li class="flex relative">
          <h2>
            <b>{{ goodies2 }}</b>
          </h2>
          <span @click="remGd2">-</span>
          <p>SERVIETTE</p>
          <span @click="addGd2">+</span>
        </li>
        <li class="flex relative">
          <h2>
            <b>{{ goodies3 }}</b>
          </h2>
          <span @click="remGd3">-</span>
          <p>TOTE BAG</p>
          <span @click="addGd3">+</span>
        </li>
        <li class="flex relative">
          <h2>{{ goodies4 }}</h2>
          <span @click="remGd4">-</span>
          <p>PRODUIT</p>
          <span @click="addGd4">+</span>
        </li>
      </ul>
      <div class="delete">
        <div @click="remGd1All"><i class="fa-solid fa-trash"></i> BANDEAU</div>
        <div @click="remGd2All">
          <i class="fa-solid fa-trash"></i> SERVIETTE
        </div>
        <div @click="remGd3All"><i class="fa-solid fa-trash"></i> TOTE BAG</div>
        <div @click="remGd4All"><i class="fa-solid fa-trash"></i> PRODUIT</div>
        <div @click="remAll" class="!w-full">
          <i class="fa-solid fa-trash"></i> Effacer tout LES LOTS
        </div>
      </div>
    </div>
  </main>
</template>

<style lang="scss" scoped>
.delete {
  @apply w-[320px] max-w-xs m-auto flex flex-wrap justify-between gap-2;
  div {
    @apply bg-red-50 h-8 flex items-center justify-center text-red-600 rounded-md cursor-pointer px-8 uppercase text-xs font-semibold w-[48.5%];
    font-family: Arial;
    i {
      @apply mr-2;
    }
  }
}

ul {
  @apply max-w-xs m-auto flex flex-wrap;
  font-family: "Arial";
}

li {
  @apply flex flex-wrap m-auto text-center justify-center mb-6 border-b pb-6 w-full;
}
li span {
  @apply inline-block text-center  bg-white w-8 h-8 rounded-3xl items-center justify-center text-2xl cursor-pointer;
}

h2 {
  @apply text-white text-5xl text-center w-full font-semibold;
}

p {
  @apply bg-blue-50 font-bold text-white border bg-transparent text-sm text-center w-36 mx-4 rounded-md flex justify-center items-center;
}

li div i {
  @apply cursor-pointer bg-red-200 text-red-600 h-7 w-7 flex justify-center items-center rounded-full;
}
</style>
<script>
export default {
  components: {},

  data() {
    return {
      goodies1: 0,
      goodies2: 0,
      goodies3: 0,
      goodies4: 0,
    };
  },
  async mounted() {
    const { data: submission } = await this.axios.get(
      `https://api.odr.promo.dev/api/v2/submissions/68b585a2489f3ba1660d0433?uid=BA4A01`
    );

    this.goodies1 = submission.rating1;
    this.goodies2 = submission.rating2;
    this.goodies3 = submission.rating3;
    this.goodies4 = submission.rating4;
  },
  methods: {
    async save() {
      try {
        const form = {
          rating1: this.goodies1,
          rating2: this.goodies2,
          rating3: this.goodies3,
          rating4: this.goodies4,
          formulaireId: "6729d54ecb3518e4f3ab3d74",
          uid: "BA4A01",
          _id: "6729d5934542a6d2ce6cbf9c",
        };
        this.axios.put(
          "https://api.odr.promo.dev/api/v2/submissions/68b58415d7a99b776c4eeacc",
          form
        );
      } catch (e) {
        console.log(e);
      }
    },
    remAll() {
      this.goodies1 = 0;
      this.goodies2 = 0;
      this.goodies3 = 0;
      this.goodies4 = 0;
      this.save();
    },
    remGd1All() {
      this.goodies1 = 0;
      this.save();
    },
    remGd2All() {
      this.goodies2 = 0;
      this.save();
    },
    remGd3All() {
      this.goodies3 = 0;
      this.save();
    },
    remGd4All() {
      this.goodies4 = 0;
      this.save();
    },
    addGd1() {
      this.goodies1++;
      this.save();
    },
    addGd2() {
      this.goodies2++;
      this.save();
    },
    addGd3() {
      this.goodies3++;
      this.save();
    },
    addGd4() {
      this.goodies4++;
      this.save();
    },
    remGd1() {
      this.goodies1--;
      if (this.goodies1 < 0) {
        this.goodies1 = 0;
      }
      this.save();
    },
    remGd2() {
      this.goodies2--;
      if (this.goodies2 < 0) {
        this.goodies2 = 0;
      }
      this.save();
    },
    remGd3() {
      this.goodies3--;
      if (this.goodies3 < 0) {
        this.goodies3 = 0;
      }
      this.save();
    },
    remGd4() {
      this.goodies4--;
      if (this.goodies4 < 0) {
        this.goodies4 = 0;
      }
      this.save();
    },
  },
};
</script>
